<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <router-link :to="{ name: event.event_type_id === 3 ? 'AlertIndex' : 'Notifications' }" class="btn btn-light">
        <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>Back
      </router-link>
      <h2>{{ event.name }}</h2>
      <a class="btn btn-light" @click="executeEvent">
        <i class="fa fa-play fa-fw" aria-hidden="true"></i> Play
      </a>
    </div>
    
    <div class="row">
      <div class="col-12 col-lg-5">
        <EventSummaryInfo class="mb-3" :event="event" />
      </div>
      <div class="col-12 col-lg-7">
        <VisualCards :event_id="event_id" />
        <StepList class="mt-3" :event_id="event_id" :event="event" :event_steps="event_steps" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EventSummaryInfo from '../../components/Event/EventSummaryInfo'
import StepList from '../../components/Event/StepList'
import VisualCards from '../../components/Event/VisualCards'
import { EVENT_TYPE } from '../../assets/js/resource-types'

export default {
  props: {
    event_id: [Number, String],
  },
  components: { EventSummaryInfo, StepList, VisualCards },
  computed: {
    ...mapGetters({
      event: 'singleEvent',
      event_steps: 'allEventSteps',
    })
  },
  watch: {
    event_id(newEventId) {
      this.getEventAndSteps(newEventId)
    }
  },
  created () {
    this.getEventAndSteps(this.event_id)
  },
  methods: {
    ...mapActions(['executeAlert', 'playNotification']),
    executeEvent() {
      if(this.event.event_type_id === EVENT_TYPE.Alert) {
        this.executeAlert(this.event.event_id)
      } else if(this.event.event_type_id === EVENT_TYPE.Announcement) {
        this.playNotification(this.event)
      }
    },
    getEventAndSteps(eventId) {
      this.$store.dispatch('getEvent', eventId)
      this.$store.dispatch('getEventSteps', eventId)
    }
  }
}
</script>

<style scoped>
</style>
